import { atom } from 'jotai/vanilla';

/**
 * Time tracking state interface
 */
export interface TimeTrackerState {
  startTimestamp: number | undefined;
  elapsedSeconds: number;
}

/**
 * Start timestamp atom - when the game started (undefined when not running)
 * Not persisted - runtime only
 */
export const startTimestampAtom = atom<number | undefined>(undefined);

/**
 * Elapsed seconds atom - seconds since game started
 * Not persisted - runtime only
 * Default: 0
 */
export const elapsedSecondsAtom = atom<number>(0);

/**
 * Paused duration atom - accumulated milliseconds spent paused
 * Not persisted - runtime only
 * Default: 0
 */
export const pausedDurationAtom = atom<number>(0);

/**
 * Pause start timestamp atom - when the current pause started
 * Not persisted - runtime only
 * Default: undefined (not paused)
 */
export const pauseStartTimestampAtom = atom<number | undefined>(undefined);

/**
 * Is paused atom - whether the game is currently paused
 * Not persisted - runtime only
 * Default: false
 */
export const isPausedAtom = atom<boolean>(false);

/**
 * Derived atom - check if timer is running
 */
export const isTimerRunningAtom = atom((get) => {
  return get(startTimestampAtom) !== undefined && !get(isPausedAtom);
});
